/* eslint-disable @nx/enforce-module-boundaries */
import Image from 'next/image';
import { Image as ImageChakra, Text } from '@mybridge/ui';
import Link from 'next/link';
// import Image from 'next/image';
import PreloadImage from 'react-preload-image';
import { Box } from '@mybridge/ui/layout';
import { VideoPlayer } from '@mybridge/ui/video-player';
import { AdVideoPlayer } from '@mybridge/ui/video-player/ad-videoPlayer';
import { VideoWithThumbnailPlayer } from '@mybridge/ui/video-player-thumbnail';
import GifPlayer from '@mybridge/ui/gif-player';
import { useContext, useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { PostBoxContext } from '../context';
import styles from './media-player.module.scss';
import { HStack, Stack } from '@mybridge/ui/layout';
import { isMobile } from 'react-device-detect';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
import { openGlobalPostModal } from 'v4/snippets/dashboard/global-post-container';
export const MediaDisplay = ({ setCurrentMediaToShow, onLoaded, isOnlyPreview,fromArticle=false,fromPublicEvent=false,fromSeperateList=false,fromIndex=false,isQuoted=false,onQuotedClick,imageAlignment='left' }) => {
  const { post, handleAdClicksRouting } = useContext(PostBoxContext);
  const router = useRouter();

  const handleImageClick = (e, img) => {
    e.preventDefault();
    e.stopPropagation();
    if (isQuoted && onQuotedClick) {
      onQuotedClick(e);
      return;
    }
    // router.push(
    //   { pathname: `/post/${id}`, query: { openMedia: encodeURIComponent(img) } },
    //   undefined,
    //   { shallow: false, scroll: false }
    // );
    openGlobalPostModal({ post, openMedia: img });
  };
  
  const {
    media,
    cover_image,
    type,
    title,
    id,
    ad_format_detail,
    video_thumbnail,
  } = post??{};
  const isArticle = type === 3;
  const isAdPost = type === 4;
  const [images_, setImages_] = useState([]);
  const [videos_, setVideos_] = useState([]);
  const [gifs_, setGifs_] = useState([]);
  const [adVideoSrc, setAdVideoSrc] = useState(null);
  const videoRef = useRef(null);

  const isProfileBannerPost =
    post?.content === 'USER_PROFILE_BANNER_PIC_UPDATE' ||
    post?.content === 'COMPANY_PROFILE_BANNER_PIC_UPDATE';

  useEffect(() => {
    prepareMedia();
  }, [media]);

  // useEffect(() => {
  //   prepareGifs();
  // }, [gif]);

  const prepareMedia = async () => {
    const vids = [];
    const imgs = [];
    const gifs = [];
    for (let m of media ?? []) {
      const { file, type } = m ?? {};
      if (type === 'VIDEO') {
        vids.push(file);
      } else if (type === 'IMAGE') {
        imgs.push(file);
      } else if (type === 'GIF') {
        gifs.push(file);
      }
    }
    setVideos_(vids);
    setImages_(imgs);
    setGifs_(gifs);
  };
  // const prepareGifs = async () => {
  //   const gs = [];
  //   if (gif?.length) {
  //     gs.push(gif);
  //   }
  //   setGifs_(gs);
  // };

  const handleLoading = (val) => {
    onLoaded?.();
  };

  const handleVideoAdDuration = (duration) => {
    if (duration?.playedSeconds > 5) {
      handleAdClicksRouting('video', id);
    }
  };

  useEffect(() => {
    if (ad_format_detail?.video) {
      setAdVideoSrc(ad_format_detail?.video);
    }
  }, [ad_format_detail?.video]);

  // console.log('adVideoSrc', adVideoSrc, videoRef);

  return (
    <>
      {videos_?.length ? (
        <Box 
          pos="relative" 
          overflow="hidden" 
          className={styles.mediaPlayer}
          onClick={(e) => {
            // Handle clicks on video area for quoted posts
            if (isQuoted && onQuotedClick) {
              const target = e.target;
              // Check if click is on video controls - look for specific video player control classes
              const isControlClick = 
                target.closest('[class*="controlCont"]') || // control container
                target.closest('[class*="playBtns"]') || // play/pause button
                target.closest('[class*="btnsCont"]') || // buttons container
                target.closest('[class*="barCont"]') || // progress bar container
                target.closest('[class*="thumbnailCont"]') || // thumbnail container (play button)
                target.closest('input[type="range"]') || // slider controls
                target.closest('button') ||
                target.tagName === 'BUTTON' ||
                target.closest('svg') || // icon buttons
                target.closest('[role="button"]');
              
              // If clicking on video area (not controls), open windowed mode
              // Only handle if it's not a control click
              if (!isControlClick) {
                // Check if click is on the video player container or ReactPlayer
                const isVideoArea = target.closest('.player') || 
                                   target.closest('[class*="mediaPlayer"]') ||
                                   target === e.currentTarget;
                
                if (isVideoArea) {
                  e.stopPropagation();
                  e.preventDefault();
                  onQuotedClick(e);
                }
              }
            }
          }}
        >
          <VideoWithThumbnailPlayer
            onLoad={() => handleLoading(false)}
            src={videos_?.[0]}
            height="100%"
            // getVideoDuration={(e) => console.log()}
            videoThumbnail={video_thumbnail}
            width="100%"
            style={{
              backgroundColor: 'black',
              // maxHeight: '70vh',
              width: '100%',
              height: '100%',
            }}
            className="player"
          />
        </Box>
      ) : (
        <>
          {isArticle ? (
            <>
              {cover_image && (
                // <Image
                //   className={styles.preloadImage}
                //   src={cover_image}
                //   lazy
                //   htmlHeight="auto"
                //   htmlWidth="100%"
                //   alt={'Post Image'}
                // />
                // <ForceSignInWrapper>
                  <Link
                    // maxH="400px"
                    overflow="hidden"
                    // w="100%"
                    href={`/articles/detail/${id}`}
                    onClick={() => {
                      localStorage?.removeItem('commentCLicked', true);
                    }}
                  >
                    <div style={{border:fromArticle||fromPublicEvent?"1px solid #E4E6EB":"",marginRight:fromSeperateList&&fromIndex&&!isMobile?'200px':"" ,height:fromArticle||fromPublicEvent?"225px":"",width:isMobile&&"96%",marginLeft:isMobile&&"auto",marginRight:isMobile?"auto":fromSeperateList&&fromIndex&&!isMobile?'200px':"",boxShadow:"0 1px 3px 0 rgba(0, 0, 0, 0.1),0 1px 2px 0 rgba(0, 0, 0, 0.06)",maxWidth:"682px"}} className={styles.articalImgContainer}>
                      <img
                        style={{ backgroundColor: '#E4E6EB', width: '100%' }}
                        src={cover_image}
                        alt={id}
                        className={styles.articalImage}
                      />
                    </div>
                    {/* <Image
                      className={styles.preloadImage}
                      src={cover_image}
                      alt={title}
                      width="640"
                      height="300"
                      loading="lazy"
                      style={{ borderRadius: '8px 8px 0 8px' }}
                    /> */}
                  </Link>
                // </ForceSignInWrapper>
              )}
            </>
          ) : (
            <>
              {images_?.length ? (
                images_.length > 1 ? (
                  <Link
                    // maxH="400px"
                    overflow="hidden"
                    borderRadius="20px"
                    // w="100%"
                    href={`/post/${id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      localStorage?.removeItem('commentCLicked', true);
                      if (isQuoted && onQuotedClick) {
                        onQuotedClick(e);
                        return;
                      }
                      openGlobalPostModal({ post, openMedia: images_?.[0] });
                    }}
                  >
                    {images_?.length >= 5 ? (
                      // Special layout for 5+ images: 2 on top row, 3 on bottom row
                      <Box position="relative" borderRadius="20px" overflow="hidden">
                        {/* Top row with 2 images */}
                        <HStack spacing="2px" mb="2px" w="100%">
                          {images_?.slice(0, 2).map((img, index) => (
                            <ImageChakra
                              key={`top-${index}`}
                              _hover={{
                                opacity: '0.5',
                                boxShadow: '0px 0px 12px 0px #00000033',
                              }}
                              style={{
                                height: '200px',
                                objectFit: 'cover',
                                borderTopLeftRadius: index === 0 ? '20px' : '0px',
                                borderTopRightRadius: index === 1 ? '20px' : '0px',
                                width: '50%',
                              }}
                              src={img}
                              onClick={(e) => handleImageClick(e, img)}
                              alt={`${id}-top-${index}`}
                              loading="lazy"
                            />
                          ))}
                        </HStack>
                        
                        {/* Bottom row with 3 images */}
                        <HStack spacing="2px" w="100%">
                          {images_?.slice(2, 5).map((img, index) => (
                            <ImageChakra
                              key={`bottom-${index}`}
                              _hover={{
                                opacity: '0.5',
                                boxShadow: '0px 0px 12px 0px #00000033',
                              }}
                              style={{
                                height: '200px',
                                objectFit: 'cover',
                                borderBottomLeftRadius: index === 0 ? '20px' : '0px',
                                borderBottomRightRadius: index === 2 ? '20px' : '0px',
                                filter: `${
                                  index === 2 && images_?.length > 5
                                    ? 'brightness(0.5)'
                                    : ''
                                }`,
                                width: '33.33%',
                              }}
                              src={img}
                              onClick={(e) => handleImageClick(e, img)}
                              alt={`${id}-bottom-${index}`}
                              loading="lazy"
                            />
                          ))}
                        </HStack>
                        
                        {/* Overlay for additional images count */}
                        {images_?.length > 5 && (
                          <Stack
                            style={{
                              position: 'absolute',
                              top: '74%',
                              left: '76%',
                              transform: 'translate(-50%, -50%)',
                              textAlign: 'center',
                            }}
                          >
                            <Text size="2rem" color="#ffffff" fontWeight="bold">
                              + {images_?.length - 5}
                            </Text>
                          </Stack>
                        )}
                      </Box>
                    ) : (
                      // Original masonry layout for less than 5 images
                      <ResponsiveMasonry
                        columnsCountBreakPoints={{
                          350: images_?.length > 4 ? 2 : 2,
                          750: images_?.length > 4 ? 2 : 2,
                          900: images_?.length > 4 ? 2 : 2,
                        }}
                      >
                        <Masonry columnsCount={1} gutter="2px">
                          {images_?.slice(0, 4).map((img, index) => (
                            <>
                              <ImageChakra
                                key={Math.random()}
                                _hover={{
                                  opacity: '0.5',
                                  boxShadow: '0px 0px 12px 0px #00000033',
                                }}
                                style={{
                                  height: `${
                                    images_?.length == 2
                                      ? '300px'
                                      : index + 1 == images_?.length - 1 &&
                                        images_?.length == 3
                                      ? '400px'
                                      : '200px'
                                  }`,
                                  filter: `${
                                    index + 1 == images_?.length - 1 &&
                                    images_?.length > 4
                                      ? 'brightness(0.5)'
                                      : ''
                                  }`,
                                  objectFit: 'cover',
                                  ...(images_?.length === 2
                                    ? {
                                        borderTopLeftRadius:
                                          index === 0 ? '20px' : '0px',
                                        borderBottomRightRadius:
                                          index === 1 ? '20px' : '0px',
                                        borderTopRightRadius:
                                          index === 0 ? '0px' : '20px',
                                        borderBottomLeftRadius:
                                          index === 1 ? '0px' : '20px',
                                      }
                                    : images_?.length >= 4 ||
                                      images_?.length >= 5
                                    ? {
                                        borderTopLeftRadius:
                                          index === 0 ? '20px' : '0px',
                                        borderTopRightRadius:
                                          index === 1 ? '20px' : '0px',
                                        borderBottomLeftRadius:
                                          index === 2 ? '20px' : '0px',
                                        borderBottomRightRadius:
                                          index === 3 ? '20px' : '0px',
                                      }
                                    : images_?.length === 3
                                    ? {
                                        borderTopLeftRadius:
                                          index === 0 ? '20px' : '0px 0px',
                                        borderTopRightRadius:
                                          index === 0 ? '20px' : '0px 0px',
                                        borderTopRightRadius:
                                          index === 1 ? '20px' : '0px 0px',
                                        borderBottomLeftRadius:
                                          index === 2 ? '20px' : '0px 0px',
                                        borderBottomRightRadius:
                                          index === 1 ? '20px' : '0px',
                                      }
                                    : {}),
                                }}
                                src={img}
                                onClick={(e) => handleImageClick(e, img)}
                                alt={id}
                                width="300"
                                height="300"
                                loading="lazy"
                              />
                              {index === 3 && images_?.length > 4 && (
                                <Stack
                                  style={{
                                    position: 'absolute',
                                    top: '74%',
                                    left: '76%',
                                    transform: 'translate(-50%, -50%)',
                                    textAlign: 'center',
                                  }}
                                >
                                  <Text size="2rem" color="#ffffff">
                                    + {images_?.length - 4}
                                  </Text>
                                </Stack>
                              )}
                            </>
                          ))}
                        </Masonry>
                      </ResponsiveMasonry>
                    )}
                  </Link>
                ) : (
                  <>
                    {/* <PreloadImage
                      className={styles.preloadImage}
                      src={images_?.[0]}
                      lazy
                    /> */}
                    <Link
                      // maxH="400px"
                      overflow="hidden"
                      // w="100%"
                      href={`/post/${id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        localStorage?.removeItem('commentCLicked', true);
                        if (isQuoted && onQuotedClick) {
                          onQuotedClick(e);
                          return;
                        }
                        openGlobalPostModal({ post, openMedia: images_?.[0] });
                      }}
                    >
                      <div className={`${styles.postImgContainer} ${imageAlignment === 'center' ? styles.centerAlign : styles.leftAlign}`}>
                        <img
                          src={images_?.[0]}
                          alt={id}
                          className={
                            isProfileBannerPost
                              ? styles.postbannerImage
                              : styles.postImage
                          }
                          style={{ minHeight: '100%' }}
                        />
                      </div>

                      {/* <Image
                        className={styles.preloadImage}
                        src={images_?.[0]}
                        alt={id}
                        width="640"
                        height="300"
                        loading="lazy"
                      /> */}
                    </Link>
                  </>
                )
              ) : (
                <>
                  {gifs_?.length ? (
                    <Box
                      pos="relative"
                      borderRadius="20px"
                      width="95%"
                      // width='100%'
                      // height="516px"
                      maxHeight="516px"
                      overflow="hidden"
                    >
                      {/* <Image
                        className={styles.preloadImage}
                        src={gifs_?.[0]}
                        lazy
                        htmlHeight="400px"
                        htmlWidth="100%"
                        alt={'Post Image'}
                      /> */}
                      {/* <ImageChakra
                        className={styles.preloadImage}
                        src={gifs_?.[0]}
                        alt={id}
                        width="640"
                        height="300"
                        loading="lazy"
                      /> */}
                      <GifPlayer
                        onLoad={() => handleLoading(false)}
                        videoUrl={gifs_?.[0]}
                        height="100%"
                        width="100%"
                        videoThumbnail={video_thumbnail}
                        style={{
                          backgroundColor: 'transparent',
                          maxHeight: '70vh',
                          width: '100%',
                          height: '100%',
                        }}
                        className="player"
                      />
                      <></>
                    </Box>
                  ) : (
                    ''
                  )}
                </>
              )}
            </>
          )}
        </>
      )}

      {isAdPost && ad_format_detail?.image ? (
        <Image
          className={styles.preloadImage}
          src={ad_format_detail?.image}
          alt={id}
          width="640"
          height="300"
          loading="lazy"
          // objectFit='cover'
          onClick={() =>
            !isOnlyPreview
              ? handleAdClicksRouting('conversion', id, media?.destination_url)
              : undefined
          }
          cursor={!isOnlyPreview ? 'pointer' : 'default'}
        />
      ) : (
        ''
      )}
      {isAdPost && adVideoSrc ? (
        <Box pos="relative" overflow="hidden" className={styles.mediaPlayer}>
          <AdVideoPlayer
            onLoad={() => handleLoading(false)}
            src={adVideoSrc}
            height="100%"
            width="100%"
            ref={videoRef}
            getVideoDuration={(e) => handleVideoAdDuration(e)}
            style={{
              backgroundColor: 'black',
              // maxHeight: '70vh',
              width: '100%',
              height: '100%',
            }}
            className="player"
          />
        </Box>
      ) : (
        ''
      )}
    </>
  );
};
